module.exports = __webpack_public_path__ + "static/img/bcg.23376a4d.webp";